<template>
  <div class="trends-report-roc-table-chart">
    <div
      :id="chartID"
      class="trends-report-roc-table-chart__chart-card"
      @click="showModal = !showModal"
    ></div>
    <BaseModal
      v-if="showModal"
      color="grey"
      rounded
      :size="fromApp ? 'app' : 'tr-modal'"
      :evenPadding="!fromApp"
      @background-clicked="hideModal"
    >
      <div class="trends-report-roc-table-chart__modal">
        <div
          :class="
            fromApp
              ? 'trends-report-roc-table-chart__modal-close mobile'
              : 'trends-report-roc-table-chart__modal-close'
          "
          @click="hideModal"
        >
          <span>X</span>
        </div>
        <div
          :class="
            fromApp
              ? 'trends-report-roc-table-chart__title mobile'
              : 'trends-report-roc-table-chart__title'
          "
        >
          <h1>{{ rowData.CompanyName }}</h1>
        </div>
        <div v-if="fromApp" class="trends-report-roc-table-chart__graph">
          <TrendsReportROCChart
            :rocData="rowData.RoCChart"
            :border="true"
            :width="deviceWidth"
            :fromReport="true"
          />
        </div>
        <div v-else class="trends-report-roc-table-chart__graph">
          <TrendsReportROCChart
            :rocData="rowData.RoCChart"
            :border="true"
            :fromReport="fromApp"
          />
        </div>
        <div v-if="!isGlobal" :class="getPhaseBoxClass">
          <div class="tr-phase-box-flex__left" v-if="phaseClass">
            <img
              :src="getPhaseClassPath"
              alt="Trends Report Phase Logo"
            />
          </div>
          <div
            :class="
              fromApp
                ? 'tr-phase-box-flex-mobile__right'
                : 'tr-phase-box-flex__right'
            "
          >
            <h4>ITR MANAGEMENT OBJECTIVE</h4>
            <div
              class="management-objective"
              :class="
                fromApp
                  ? 'tr-phase-box-flex-mobile__objective'
                  : 'tr-phase-box-flex__objective'
              "
              v-html="rowData.ManagementObjectives"
            ></div>
          </div>
        </div>
        <div
          :class="
            fromApp
              ? 'trends-report-roc-table-chart__link mobile'
              : 'trends-report-roc-table-chart__link'
          "
          @click="viewReport"
          v-if="!isGlobal"
        >
          <p>Read Full Article</p>
          <img class="pop-out" :src="getPopOutPath" />
        </div>
      </div>
    </BaseModal>
  </div>
</template>

<script>
  import BaseModal from '~/components/base/BaseModal.vue';
  import TrendsReportROCChart from '~/components/trendsreport/TrendsReportROCChart.vue';

  export default {
    name: 'TrendsReportROCTableChart',
    components: {
      BaseModal,
      TrendsReportROCChart,
    },
    props: {
      height: {
        type: String,
        default: () => {
          return '50';
        },
      },
      width: {
        type: String,
        default: () => {
          return '80';
        },
      },
      rowData: {
        type: Object,
        required: true,
      },
      isGlobal: {
        type: Boolean,
        default: false,
      },
      fromApp: {
        type: Boolean,
        default: false,
      },
      imagespath: {
        type: String,
        required: false,
      },
    },
    data: () => ({
      chartLayout: {},
      primaryHistoricDataTrace: {},
      chartID: (Math.random() + 1).toString(36).substring(3),
      modalID: (Math.random() + 1).toString(36).substring(3),
      showModal: false,
      deviceWidth: 0,
    }),
    mounted() {
      this.buildChartData();
      if (this.fromApp) {
        this.deviceWidth = window.innerWidth - 92;
      }
    },
    computed: {
      phaseClass() {
        if (this.rowData.CurrentPhase === 'A') {
          return 'phase-a';
        } else if (this.rowData.CurrentPhase === 'B') {
          return 'phase-b';
        } else if (this.rowData.CurrentPhase === 'C') {
          return 'phase-c';
        } else if (this.rowData.CurrentPhase === 'D') {
          return 'phase-d';
        } else {
          return '';
        }
      },
      getPhaseBoxClass() {
        let defaultClass = 'trends-report-roc-table-chart__phase';
        if (this.fromApp) {
          defaultClass += ` tr-phase-box-flex-mobile ${this.phaseClass}`;
        } else {
          defaultClass += ` tr-phase-box-flex ${this.phaseClass}`;
        }
        return defaultClass;
      },
      getPopOutPath() {
        if(this.imagespath && this.imagespath.length > 0) {
          return `${this.imagespath}/images/pop-out-blue.png`;
        }
        return '/images/pop-out-blue.png';
      },
      getPhaseClassPath() {
        if (this.imagespath && this.imagespath.length > 0) {
          return `${this.imagespath}/images/tr-${this.phaseClass}.png`;
        }
        return `/images/tr-${this.phaseClass}.png`;
      },
    },
    methods: {
      buildChartData() {
        let monthYear = [];
        let primaryHistoricData = [];
        for (
          let index = 0;
          index < this.rowData.RoCChart.PrimaryHistoricData.length;
          index++
        ) {
          const element = this.rowData.RoCChart.PrimaryHistoricData[index];
          monthYear.push(element.MonthYear);
          primaryHistoricData.push(element.DataPoint);
        }

        this.primaryHistoricDataTrace = {
          type: 'scatter',
          mode: 'scatter',
          x: monthYear,
          y: primaryHistoricData,
          name: this.rowData.RoCChart.PrimaryMetric,
          line: {
            width: 0.5,
            color: '#012249',
          },
          yaxis: 'y1',
          xaxis: 'x',
          visible: true,
        };

        this.chartLayout = {
          showlegend: false,
          autosize: true,
          dragmode: false,
          hovermode: false,
          yaxis: {
            title: '',
            showline: false,
            zeroLine: true,
            autotick: true,
            showgrid: false,
            ticks: '',
            showticklabels: false,
          },
          xaxis: {
            visible: false,
          },
          yaxis2: {
            title: '',
            zeroline: false,
            autotick: true,
            automargin: true,
            showgrid: false,
            showline: true,
            ticks: 'outside',
            side: 'right',
          },
          width: this.width,
          height: this.height,
          margin: {
            t: 0,
            l: 2,
            r: 2,
            b: 1,
          },
        };

        this.plotChart();
      },
      plotChart() {
        Plotly.react(
          this.chartID,
          [this.primaryHistoricDataTrace],
          this.chartLayout,
          {
            responsive: true,
            staticPlot: true,
            displaylogo: false,
            displayModeBar: false,
          }
        ).then((chartData) => {
          this.adjustChart();
        });
      },
      adjustChart() {
        let layoutObject = this.getTableRanges();
        Plotly.update(this.chartID, null, layoutObject);
      },
      getTableRanges: function () {
        let y1_min = this.rowData.RoCChart.MinY1;
        let y1_max = this.rowData.RoCChart.MaxY1;

        return {
          'yaxis.range': [y1_min, y1_max],
        };
      },
      hideModal() {
        this.showModal = false;
      },
      viewReport() {
        window.location.href = `${this.rowData.Link}/${this.rowData.TREditionID}`;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .trends-report-roc-table-chart {
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;

    &__chart-card {
      &:hover {
        cursor: pointer;
        box-shadow:
          0 4px 8px 0 rgba(0, 0, 0, 0.2),
          0 6px 20px 0 rgba(0, 0, 0, 0.19);
      }
    }

    &__modal {
      // position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
    }
    &__modal-close {
      color: var(--itr-white);
      font-size: 18px;
      font-weight: 700;
      height: 26px;
      width: 26px;
      border-radius: 50%;
      background: var(--itr-blue);
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 12px;
      right: 12px;
      cursor: pointer;
      &.mobile {
        font-size: 10px;
        height: 18px;
        width: 18px;
      }
    }
    &__link {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 16px;
      font-weight: 600;
      cursor: pointer;
      p {
        color: #000000 !important;
      }
      .pop-out {
        color: var(--itr-blue);
        margin-left: 8px;
      }
      &.mobile {
        font-size: 14px;
      }
    }
    .tr-phase-box-flex {
      margin: 1rem 0 1.5rem 0;
      width: 90%;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-wrap: nowrap !important;
      gap: 2rem;
      border-radius: 10px;
      padding: 40px;
      img {
        max-width: 70px;
      }
      &__left {
        color: var(--itr-white);
      }
      &__right {
        color: var(--itr-white);
        h4 {
          color: var(--itr-white);
          margin-top: 0;
        }
        div {
          font-size: 18px;
          color: var(--itr-white) !important;
        }
      }
      &__objective {
        * {
          color: var(--itr-white) !important;
        }
        *::before {
          color: var(--itr-white) !important;
        }
        *::after {
          color: var(--itr-white) !important;
        }
      }
      .management-objective {
        * {
          font-size: 17px !important;
          color: var(--itr-white) !important;
          background-color: transparent !important;
          font-family: 'Open Sans', sans-serif !important;
        }
      }
    }
    .tr-phase-box-flex-mobile {
      margin: 0.5rem 0 1rem 0;
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-wrap: nowrap !important;
      gap: 10px;
      border-radius: 10px;
      padding: 12px;
      width: 95%;
      img {
        max-width: 47px;
      }
      &__left {
        color: var(--itr-white);
      }
      &__right {
        color: var(--itr-white);
        h4 {
          color: var(--itr-white);
          margin-top: 0;
          margin-bottom: 2px;
          font-size: 13px;
        }
        div {
          font-size: 11px;
          font-weight: normal;
          color: var(--itr-white) !important;
        }
      }
      &__objective {
        * {
          color: var(--itr-white) !important;
        }
        *::before {
          color: var(--itr-white) !important;
        }
        *::after {
          color: var(--itr-white) !important;
        }
      }
      .management-objective {
        * {
          font-size: 17px !important;
          color: var(--itr-white) !important;
          background-color: transparent !important;
          font-family: 'Open Sans', sans-serif !important;
        }
      }
    }
    .phase-a {
      background-color: var(--itr-tr-blue);
    }
    .phase-b {
      background-color: var(--itr-tr-green);
    }
    .phase-c {
      background-color: var(--itr-tr-orange);
    }
    .phase-d {
      background-color: var(--itr-tr-red);
    }
    &__title {
      text-align: center;
      h1 {
        line-height: 1.2;
      }
      &.mobile {
        h1 {
          font-size: 18px;
        }
      }
    }
  }
</style>
